<template>
  <div class="agreement-container">
    <div class="agreement-header">
      <div class="header-title">服务条款</div>
    </div>
    <div class="agreement-content">
        <h2>欢迎使用{{name}}！</h2>
                <p>请务必认真阅读和理解本《服务条款》（下称"本条款"）。本条款由您（下称"用户"）与{{companyName}}（下称"我们"或"公司"）就您使用"{{name}}"在线调查问卷服务（下称"本服务"）所订立的相关权利义务规范。</p>
                
                <h3>一、 服务说明</h3>
                <p>1.1 "{{name}}"是由{{companyName}}提供的一个在线调查问卷创建、发布、回收、统计系统。用户可通过本服务创建、编辑、发布、回收调查问卷，并对回收的数据进行统计与分析。</p>
                <p>1.2 用户理解并同意，本服务仅提供技术平台，用户通过本服务创建、发送的任何问卷内容、收集的数据以及由此产生的一切后果，均由用户自行负责。</p>
                
                <h3>二、 用户账户</h3>
                <p>2.1 您需要注册一个账户才能使用本服务。您必须提供真实、准确、完整、最新的注册信息，并及时更新。</p>
                <p>2.2 您的账户仅供您个人或您的实体使用，不得转让、借用、租用或分享给任何第三方。您应对您账户下的一切活动承担全部责任。</p>
                <p>2.3 您有责任妥善保管您的账户名和密码。因您泄露、遗失账户信息或授权他人使用而导致的任何损失，由您自行承担。</p>
                
                <h3>三、 使用规则</h3>
                <p>3.1 <strong>用户承诺合法使用</strong>。您承诺并保证在使用本服务时：</p>
                <ul>
                    <li>遵守所有适用的中国法律法规。</li>
                    <li>不利用本服务从事任何非法、欺诈、诽谤、侮辱、恐吓、骚扰、侵犯他人隐私、知识产权或其他合法权益的活动。</li>
                    <li>在通过问卷收集他人信息前，确保已获得信息主体的明确同意，并向其清晰地说明信息收集的目的、方式和范围。您应独立承担作为"数据控制者"的法律责任。</li>
                    <li>不发布或传播任何病毒、木马等恶意代码。</li>
                    <li>不试图干扰或破坏本服务的正常运行。</li>
                </ul>
                
                <p>3.2 <strong>禁止内容</strong>。您不得在问卷内容、封面或任何通过本服务传播的信息中包含以下内容：</p>
                <ul>
                    <li>反对宪法所确定的基本原则的。</li>
                    <li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。</li>
                    <li>损害国家荣誉和利益的。</li>
                    <li>煽动民族仇恨、民族歧视，破坏民族团结的。</li>
                    <li>破坏国家宗教政策，宣扬邪教和封建迷信的。</li>
                    <li>散布谣言，扰乱社会秩序，破坏社会稳定的。</li>
                    <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的。</li>
                    <li>侮辱或者诽谤他人，侵害他人合法权益的。</li>
                    <li>含有法律、行政法规禁止的其他内容的。</li>
                </ul>
                
                <h3>四、 免责声明</h3>
                <p>本服务按"现状"和"可提供"的状态提供。我们在法律允许的最大范围内，不就因使用或无法使用本服务所导致的任何间接、附带、特殊、后果性的损失或损害（包括但不限于利润损失、数据丢失、商誉损失）承担赔偿责任。</p>
                
                <h3>五、 终止服务</h3>
                <p>如您违反本条款的任何规定，我们有权在不事先通知的情况下，立即暂停或终止向您提供服务，并删除您的账户和数据。您也可以随时通过注销账户的方式终止使用本服务。</p>
                
                <h3>六、 法律适用与管辖</h3>
                <p>本条款的订立、执行和解释及争议的解决均适用中华人民共和国法律。如双方就本条款内容或其执行发生任何争议，应首先友好协商解决；协商不成时，任何一方均可将争议提交至<strong>{{companyName}}所在地有管辖权的人民法院</strong>诉讼解决。</p>
                
                <h3>七、 其他</h3>
                <p>我们保留随时更新本条款的权利。更新后的条款将在网站上公布并生效。如您继续使用本服务，即视为接受更新后的条款。</p>
    </div>
  </div>
</template>

<script>
import config from "@/utils/config";
export default {
  name: 'AgreementPage',
  data() {
    return {
        name: config.name,
        companyName: config.companyName,
      // 页面数据
    }
  },
  mounted() {
    // 页面加载时的初始化操作
  }
}
</script>

<style scoped>
.agreement-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  min-height: 80vh;
}

.agreement-header {
  margin-bottom: 30px;
  text-align: center;
}

.header-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  padding: 20px 0;
  border-bottom: 1px solid #e8e8e8;
}

.agreement-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.agreement-content h2 {
  font-size: 22px;
  margin-bottom: 20px;
  color: #333;
}

.agreement-content h3 {
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 15px;
  color: #333;
}

.agreement-content p {
  font-size: 14px;
  line-height: 2;
  color: #666;
  margin-bottom: 10px;
}



@media (max-width: 768px) {
  .agreement-container {
    padding: 10px;
  }
  
  .agreement-content {
    padding: 20px;
  }
  
  .agreement-content h2 {
    font-size: 20px;
  }
  
  .agreement-content h3 {
    font-size: 16px;
  }
  
  .agreement-content p {
    font-size: 13px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Agreement/agreement.vue